"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasNonHttpRequestScheme = hasNonHttpRequestScheme;
exports.hasHttpRequestScheme = hasHttpRequestScheme;
exports.hasValidUrlScheme = hasValidUrlScheme;
exports.isRawUrl = isRawUrl;

var _hubl = require("./hubl");

function hasNonHttpRequestScheme(url) {
  return url.indexOf('mailto:') === 0 || url.indexOf('tel:') === 0;
}

function hasHttpRequestScheme(url) {
  return url.indexOf('http:') === 0 || url.indexOf('https:') === 0;
}

function hasValidUrlScheme(url) {
  return hasHttpRequestScheme(url) || hasNonHttpRequestScheme(url);
}

function isRawUrl() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var trimmedInput = input.trim();
  return hasValidUrlScheme(trimmedInput) || trimmedInput.indexOf('//') === 0 || trimmedInput.indexOf('#') === 0 || (0, _hubl.getHublVariable)(input) !== null;
}